import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  TemplateRef,
} from '@angular/core';
import { RRIStepper } from '../../interfaces/stepper.interface';

@Component({
  selector: 'rr-stepper[stepperList]',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
})
export class StepperComponent implements OnChanges {
  @Input() stepperList: RRIStepper[];
  @Input() getStepperDisableNextButtonFunction: (
    lastActiveStep: RRIStepper,
  ) => boolean;
  @Output() finshStepper: EventEmitter<void> = new EventEmitter<void>();
  constructor(private _cdRef: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['stepperList'].currentValue &&
      changes['stepperList'].currentValue.length > 0
    ) {
      this._cdRef.detectChanges();
    }
  }

  public getStepperClass() {
    if (!this.stepperList || this.stepperList.length === 0) {
      return '';
    }
    const difResult = 12 / this.stepperList?.length;
    return 'col-' + Math.floor(difResult);
  }
  public getActiveStepperText(): string {
    const lastActiveItem = this.getLastActiceOrNextItem();
    if (!lastActiveItem) {
      return null;
    }
    return lastActiveItem.stepName;
  }
  public getActiveTemplateName(): TemplateRef<any> {
    const lastActiveItem = this.getLastActiceOrNextItem();
    if (!lastActiveItem) {
      return null;
    }
    return lastActiveItem.template;
  }
  public showBackButton(): boolean {
    if (!this.stepperList || this.stepperList.length === 0) {
      return false;
    }
    const orderedList = this.stepperList.sort((a, b) => {
      return a.order - b.order;
    });
    const activeItem = this.getLastActiceOrNextItem();
    if (!activeItem) {
      return false;
    }
    const itemIndex = orderedList.findIndex(
      (o) => o.stepId === activeItem.stepId,
    );
    if (itemIndex === -1 || itemIndex === 0) {
      return false;
    }
    return true;
  }
  public showNextButton(): boolean {
    const activeItem = this.getLastActiceOrNextItem(true);
    if (!activeItem) {
      return false;
    }
    return true;
  }
  public showFinishButton(): boolean {
    const activeItem = this.getLastActiceOrNextItem(true);
    if (!activeItem) {
      return true;
    }
    return false;
  }
  public nextPage() {
    const nextItem = this.getLastActiceOrNextItem(true);
    if (!nextItem) {
      return null;
    }
    nextItem.isActive = true;
  }
  public backPage() {
    const item = this.getLastActiceOrNextItem();
    if (!item) {
      return null;
    }
    item.isActive = false;
  }
  public finishStep() {
    this.finshStepper.emit();
  }
  public getStepperDisableNextButton() {
    if (!this.getStepperDisableNextButtonFunction) {
      return false;
    }
    return this.getStepperDisableNextButtonFunction(
      this.getLastActiceOrNextItem(),
    );
  }
  private getLastActiceOrNextItem(getNextItem: boolean = false): RRIStepper {
    if (!this.stepperList || this.stepperList.length === 0) {
      return null;
    }
    const orderedList = this.stepperList.sort((a, b) => {
      return a.order - b.order;
    });
    for (let itemIndex = 0; itemIndex < orderedList.length; itemIndex++) {
      if (itemIndex === orderedList.length - 1) {
        if (getNextItem === true) {
          return null;
        }
        return orderedList[itemIndex];
      }
      const nextItemIndex = itemIndex + 1;
      const actualItem = orderedList[itemIndex];
      const nextItem = orderedList[nextItemIndex];
      if (actualItem.isActive === true && nextItem.isActive === false) {
        if (getNextItem === true) {
          return nextItem;
        }
        return actualItem;
      }
    }
    return null;
  }
}
